module.exports = __webpack_public_path__ + "reports.png?eb5f6ce1a443ee8ce2f52ba86c0f22c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reports.png
// module id = 1002
// module chunks = 2